import * as $runtime from "../runtime.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dNullable from "../Data.Nullable/index.js";
import * as Specular$dInternal$dEffect from "../Specular.Internal.Effect/index.js";
import {setupObserver} from "./foreign.js";
const observe = () => () => params => {
  const $0 = {threshold: 0.0, rootSelector: Data$dMaybe.Nothing, debounceTimeMs: 0.0, ...params};
  return (node, cleanupEffects) => {
    const cleanup = setupObserver(node)({
      threshold: $0.threshold,
      onVisible: $0.onVisible,
      rootSelector: (() => {
        if ($0.rootSelector.tag === "Nothing") { return Data$dNullable.null; }
        if ($0.rootSelector.tag === "Just") { return Data$dNullable.notNull($0.rootSelector._1); }
        $runtime.fail();
      })(),
      debounceTimeMs: $0.debounceTimeMs
    })();
    return Specular$dInternal$dEffect.pushDelayed(cleanupEffects)(cleanup)();
  };
};
export {observe};
export * from "./foreign.js";
